import { useContext, useEffect, useState } from "react";
import DropDownInput from "../../../helperComponents/DropDownInput";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import onChangePermissionGuard from "../../../../controllers/customControllerForCS/onChangePermissionGuard";
import isFieldViewPermissionAllowed from "../../../../controllers/customControllerForCS/isFieldViewPermissionAllowed";

export default function SiteDropDownInput({
  onChange,
  label,
  value,
  style,
  permissionName,
}) {
  const { preloadedSites } = useContext(Context);

  onChange = onChangePermissionGuard({ onChange, permissionName });

  let viewAllowed = isFieldViewPermissionAllowed({ permissionName });

  if (!viewAllowed) return false;

  if (!preloadedSites) return null;
  let locations = [];

  for (let key in preloadedSites) {
    let item = preloadedSites[key];
    locations.push({
      value: item._id,
      label: item.placeName,
    });
  }

  // console.log("locations-----", locations);

  return (
    <DropDownInput
      style={style}
      value={value}
      label={label}
      onChange={onChange}
      options={[
        { value: null, label: "Non affecté" },
        ...locations,
      ]}
    />
  );
}
